import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { LandingButton } from './landing-button';

type WorkflowCardDef = {
  title: string;
  subtitle: string;
  description: string;
  buttonText: string;
  icon: React.ReactNode;
};

const RavenApiWorkflowSectionIcons: Record<string, React.ReactNode> = {
  Dashboard: (
    <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.012 30.5C25.656 30.5 25.363 30.384 25.133 30.152C24.903 29.919 24.788 29.631 24.788 29.288V23.012C24.788 22.656 24.904 22.363 25.136 22.133C25.369 21.903 25.657 21.788 26 21.788H32.2775C32.6335 21.788 32.926 21.9045 33.155 22.1375C33.384 22.3705 33.499 22.658 33.5 23V29.2775C33.5 29.6335 33.384 29.926 33.152 30.155C32.92 30.384 32.632 30.499 32.288 30.5H26.012ZM20 18.212C19.657 18.212 19.3695 18.096 19.1375 17.864C18.9055 17.632 18.789 17.344 18.788 17V10.7225C18.788 10.3675 18.9045 10.075 19.1375 9.845C19.3705 9.615 19.658 9.5 20 9.5H32.288C32.632 9.5 32.92 9.616 33.152 9.848C33.384 10.08 33.5 10.368 33.5 10.712V16.9895C33.5 17.3445 33.384 17.637 33.152 17.867C32.919 18.097 32.631 18.212 32.288 18.212H20ZM7.71201 30.5C7.36901 30.5 7.08101 30.384 6.84801 30.152C6.61501 29.92 6.49901 29.632 6.50001 29.288V23.012C6.50001 22.656 6.61601 22.363 6.84801 22.133C7.08001 21.903 7.36801 21.788 7.71201 21.788H20C20.343 21.788 20.631 21.904 20.864 22.136C21.097 22.368 21.213 22.656 21.212 23V29.2775C21.212 29.6335 21.096 29.926 20.864 30.155C20.632 30.384 20.344 30.499 20 30.5H7.71201ZM7.72251 18.212C7.36751 18.212 7.07501 18.096 6.84501 17.864C6.61501 17.632 6.50001 17.344 6.50001 17V10.7225C6.50001 10.3675 6.61601 10.075 6.84801 9.845C7.08001 9.615 7.36801 9.5 7.71201 9.5H13.9895C14.3445 9.5 14.637 9.616 14.867 9.848C15.097 10.08 15.212 10.368 15.212 10.712V16.9895C15.212 17.3445 15.096 17.637 14.864 17.867C14.631 18.097 14.343 18.212 14 18.212H7.72251ZM20.288 16.712H32V11H20.288V16.712ZM8.00001 29H19.712V23.288H8.00001V29ZM26.288 29H32V23.288H26.288V29ZM8.00001 16.712H13.712V11H8.00001V16.712Z"
        fill="#DED6E0"
      />
    </svg>
  ),
  Form: (
    <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2868_385)">
        <path
          d="M5.232 33.7933C4.336 33.7933 3.57333 33.4807 2.944 32.8554C2.31467 32.2302 2 31.4731 2 30.5842V5.20914C2 4.32158 2.31467 3.5645 2.944 2.9379C3.57333 2.31263 4.336 2 5.232 2H30.77C31.6633 2 32.4253 2.31263 33.056 2.9379C33.6853 3.56317 34 4.32091 34 5.21113V17.0343C33.6493 16.9137 33.3133 16.8157 32.992 16.7402C32.672 16.666 32.3413 16.5918 32 16.5176V5.21113C32 4.90512 31.872 4.62428 31.616 4.3686C31.36 4.11293 31.0773 3.98576 30.768 3.98708H5.232C4.924 3.98708 4.64133 4.11426 4.384 4.3686C4.12667 4.62295 3.99867 4.90379 4 5.21113V30.5842C4 30.8889 4.128 31.1691 4.384 31.4247C4.64 31.6804 4.922 31.8076 5.23 31.8063H16.562C16.61 32.1772 16.672 32.5223 16.748 32.8415C16.824 33.1595 16.922 33.4767 17.042 33.7933H5.232ZM4 29.8192V31.8063V3.98708V16.5176V16.3686V29.8192ZM9 26.3815H16.92C16.9933 26.0411 17.0933 25.7119 17.22 25.3939L17.62 24.3924H9V26.3815ZM9 18.8902H22.16C22.8173 18.4319 23.4647 18.0437 24.102 17.7258C24.7393 17.4065 25.4233 17.1562 26.154 16.9747V16.9031H9V18.8902ZM9 11.3989H27V9.41182H9V11.3989ZM30 38C27.772 38 25.882 37.2283 24.33 35.685C22.7767 34.1417 22 32.2633 22 30.0497C22 27.8361 22.7767 25.9576 24.33 24.4143C25.8833 22.871 27.7733 22.1 30 22.1013C32.2267 22.1027 34.1173 22.8737 35.672 24.4143C37.2267 25.955 38.0027 27.8334 38 30.0497C38 32.262 37.224 34.1398 35.672 35.6831C34.1173 37.2264 32.2267 37.998 30 37.998M29.232 35.7804H30.77V30.8127H35.77V29.2827H30.77V24.315H29.23V29.2827H24.23V30.8127H29.23L29.232 35.7804Z"
          fill="#C4B6C9"
        />
      </g>
      <defs>
        <clipPath id="clip0_2868_385">
          <rect fill="white" height="36" transform="translate(2 2)" width="36" />
        </clipPath>
      </defs>
    </svg>
  ),
  Workspace: (
    <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.549 32C10.563 32 9.725 31.655 9.035 30.965C8.345 30.275 8 29.4375 8 28.4525V20C8 19.53 8.088 19.08 8.264 18.65C8.44 18.22 8.6935 17.8385 9.0245 17.5055L17.4755 9.053C17.8245 8.699 18.2195 8.435 18.6605 8.261C19.1015 8.087 19.548 8 20 8C20.45 8 20.89 8.085 21.32 8.255C21.751 8.426 22.1425 8.692 22.4945 9.053L30.947 17.5055C31.276 17.8345 31.534 18.2145 31.721 18.6455C31.908 19.0765 32.001 19.528 32 20V28.4525C32 29.4375 31.6525 30.275 30.9575 30.965C30.2615 31.655 29.4165 32 28.4225 32H11.549ZM11.549 30.5H28.424C29.012 30.5 29.505 30.304 29.903 29.912C30.301 29.519 30.5 29.032 30.5 28.451V20C30.5 19.716 30.448 19.45 30.344 19.202C30.24 18.954 30.084 18.7355 29.876 18.5465L24.0245 12.6845L21.032 15.668L26.375 20.981V26.375H13.625V20.981L22.955 11.624L21.425 10.094C21.167 9.837 20.907 9.6735 20.645 9.6035C20.383 9.5335 20.164 9.499 19.988 9.5C19.812 9.501 19.5875 9.5405 19.3145 9.6185C19.0415 9.6965 18.776 9.865 18.518 10.124L10.094 18.545C9.906 18.733 9.76 18.9515 9.656 19.2005C9.552 19.4495 9.5 19.716 9.5 20V28.4525C9.5 29.0325 9.6965 29.5185 10.0895 29.9105C10.4825 30.3025 10.969 30.499 11.549 30.5ZM15.125 24.875H24.875V21.6125L20 16.7375L15.125 21.6125V24.875Z"
        fill="#C4B6C9"
      />
    </svg>
  ),
  Launch: (
    <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.843 25.862L27.437 16.268L26.375 15.206L17.843 23.738L13.568 19.463L12.506 20.525L17.843 25.862ZM20.0045 33.5C18.1385 33.5 16.3835 33.146 14.7395 32.438C13.0965 31.729 11.667 30.767 10.451 29.552C9.235 28.337 8.2725 26.909 7.5635 25.268C6.8545 23.627 6.5 21.8725 6.5 20.0045C6.5 18.1365 6.8545 16.3815 7.5635 14.7395C8.2715 13.0965 9.232 11.667 10.445 10.451C11.658 9.235 13.0865 8.2725 14.7305 7.5635C16.3745 6.8545 18.1295 6.5 19.9955 6.5C21.8615 6.5 23.6165 6.8545 25.2605 7.5635C26.9035 8.2715 28.333 9.2325 29.549 10.4465C30.765 11.6605 31.7275 13.089 32.4365 14.732C33.1455 16.375 33.5 18.1295 33.5 19.9955C33.5 21.8615 33.146 23.6165 32.438 25.2605C31.73 26.9045 30.768 28.334 29.552 29.549C28.336 30.764 26.908 31.7265 25.268 32.4365C23.628 33.1465 21.8735 33.501 20.0045 33.5ZM20 32C23.35 32 26.1875 30.8375 28.5125 28.5125C30.8375 26.1875 32 23.35 32 20C32 16.65 30.8375 13.8125 28.5125 11.4875C26.1875 9.1625 23.35 8 20 8C16.65 8 13.8125 9.1625 11.4875 11.4875C9.1625 13.8125 8 16.65 8 20C8 23.35 9.1625 26.1875 11.4875 28.5125C13.8125 30.8375 16.65 32 20 32Z"
        fill="#C4B6C9"
      />
    </svg>
  ),
};
const WorkflowCards: WorkflowCardDef[] = [
  // Row 1 — 2 cards (each half width)
  {
    get title() {
      return t('workspace.dashboard');
    },
    get subtitle() {
      return t('landing.buildAMonitoringDashboard');
    },
    get description() {
      return t('landing.buildARealTimeDashboardForYourComplianceTeam');
    },
    get buttonText() {
      return t('extra.buildDashboard');
    },
    icon: RavenApiWorkflowSectionIcons.Dashboard,
  },
  {
    get title() {
      return t('landing.form');
    },
    get subtitle() {
      return t('landing.buildAClientIntakeFlow');
    },
    get description() {
      return t('landing.buildFrontEndFormsThatSubmitNewClientsTo');
    },
    get buttonText() {
      return t('extra.buildIntake');
    },
    icon: RavenApiWorkflowSectionIcons.Form,
  },
  {
    get title() {
      return t('landing.workspace');
    },
    get subtitle() {
      return t('landing.buildAReviewerWorkspace');
    },
    get description() {
      return t('landing.aFullWorkspaceForComplianceReviewersSeeEvidenceAdd');
    },
    get buttonText() {
      return t('extra.buildWorkspace');
    },
    icon: RavenApiWorkflowSectionIcons.Workspace,
  },
  {
    get title() {
      return t('landing.launch');
    },
    get subtitle() {
      return t('landing.launchYourDueDiligencePlatform');
    },
    get description() {
      return t('landing.theFinalEndToEndFrontEndFromSubmitting');
    },
    get buttonText() {
      return t('extra.buildLaunch');
    },
    icon: RavenApiWorkflowSectionIcons.Launch,
  },
];

export const RavenApiWorkflowSection = ({ className }: { className?: string }) => {
  useLocale();

  return (
    <section className={className}>
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        {/* Badge */}
        <span className="mb-4 inline-block rounded-full bg-[#BEC7F4CC] px-3 py-1 font-medium text-landing-pill-text text-xs">
          {t('landing.ravenApiWorkflows')}{' '}
        </span>

        {/* Heading */}
        <h2 className="mb-3 font-bold font-libre-baskerville text-4xl text-[#93A2EC]">
          {t('landing.buildRavenWorkflowsYourself')}{' '}
        </h2>

        {/* Subtitle */}
        <p className="mb-10 text-background text-sm">
          {t('landing.stepByStepGuidedWorkflowsStartWithATemplate')}{' '}
        </p>

        {/* Cards grid */}
        <div className="grid grid-cols-2 gap-4">
          {WorkflowCards.map((card) => (
            <div
              className="col-span-1 flex flex-col items-start justify-start gap-5 rounded-xl p-6"
              key={card.title}
              style={{
                background:
                  'linear-gradient(135.7deg, rgba(149, 123, 156, 0.9) 15.82%, rgba(62, 62, 116, 0.9) 85.35%)',
              }}
            >
              <div className="flex h-8 items-center justify-center gap-2">
                <div>{card.icon}</div>
                <h3 className="font-medium text-sm">{card.title}</h3>
              </div>
              <div className="flex flex-col items-start justify-start gap-2">
                <p className="text-background text-sm">{card.subtitle}</p>
                <p className="text-background text-xs">{card.description}</p>
              </div>
              <LandingButton
                className="w-auto bg-[#DED6E0E5] font-medium text-[#7B6184] text-[16px] md:w-48"
                size="sm"
                variant="ghost"
              >
                {card.buttonText}
              </LandingButton>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
